/**
 * Which invoice-circle URL a request resolves to: the master's by-slug route,
 * or the caller's own.
 *
 * ── Why this is one exported helper ──────────────────────────────────────
 *
 * The read and the write each carried their own copy of the rule, and they
 * drifted the moment there were two: the master by-slug route was added and the
 * read was repointed at it, while the write kept posting to the own-tenant URL.
 * A master's slug was therefore dropped from the URL and the request answered
 * 404 `account_no_tenant` — so kolula staff, who operate production as masters,
 * could not seed a circle at all.
 *
 * ── Why it is its own module rather than a function in the slice ──────────
 *
 * So a test can reach it. Importing `invoiceApiSlice` pulls in the axios base
 * query and, through it, Auth0, which jest cannot transform. Same reasoning as
 * `api/tenantCacheKey.ts`: this module imports nothing of ours.
 *
 * `/admin` is supplied by the new-backend base query, so it is absent here by
 * design — writing it again is what made five slices request `/admin/admin/...`
 * and 404 (#2261, #2266).
 */
export const invoiceCircleUrl = (slug?: string): string => (
    slug ? `/tenants/${encodeURIComponent(slug)}/invoice-circle` : '/account/invoice-circle'
);
